import React from 'react';

import { Styled } from './step-counter.styles';

interface StepCounterProps {
  numberOfSteps?: number;
  currentStep?: number;
  allComplete?: boolean;
}

const createRangeArray = (length: number): number[] => [
  ...Array(length).keys(),
];

export const StepCounter: React.FC<StepCounterProps> = ({
  numberOfSteps = 4,
  currentStep = 0,
  allComplete = false,
}) => {
  if (allComplete) {
    currentStep = numberOfSteps;
  }

  return (
    <Styled.StepCounterContainer>
      {createRangeArray(numberOfSteps).map((idx) => (
        <React.Fragment key={idx}>
          {idx === currentStep && <Styled.StepCounterItem />}
          {idx > currentStep && <Styled.StepCounterItem future />}
          {idx < currentStep && <Styled.StepCounterItem past />}
          {idx !== numberOfSteps - 1 && (
            <Styled.StepCounterSeparator past={idx < currentStep} />
          )}
        </React.Fragment>
      ))}
    </Styled.StepCounterContainer>
  );
};
